
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import { Observer } from 'mobx-vue'
import AUtils, { formatEndTimeCountdown } from '@xt/client/utils/activities/index'
import type { ActivityBtn, CalligraphyLevel2JsonResp } from '@xt/client/utils/activities/types.d.ts'

@Observer
@Component({
  components: {
    LazyImg
  }
})
export default class CourseCard extends Vue {
  @Prop({ required: true }) readonly dataSource!: CalligraphyLevel2JsonResp

  timer: ReturnType<typeof setInterval> | null = null
  countDown: string = ''

  showGiftBtn: boolean = false
  btnConfig: ActivityBtn | null = null
  allCourseHasbuy: boolean = false

  get timeShow() {
    return this.countDown ? this.countDown : this.btnConfig ? this.btnConfig.time : ''
  }

  get discount() {
    return this.dataSource.originalPrice - this.dataSource.price
  }

  get UserStore() {
    return this.$store.$storeUser
  }

  clearTick() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }

  getCountDown(endTime: number) {
    const res = formatEndTimeCountdown(endTime)

    if (!res) return ''

    if (res.days) {
      return `剩余${res.days}天`
    }

    return `剩余${res.hours}时${res.minutes}分${res.seconds}秒`
  }

  startTick() {
    if (!this.btnConfig || !this.btnConfig.countdown) return

    const { endTime } = this.btnConfig.countdown

    this.countDown = this.getCountDown(endTime)

    this.timer = setInterval(() => {
      this.countDown = this.getCountDown(endTime)
    }, 1000)
  }

  async init() {
    this.allCourseHasbuy = AUtils.isAllCourseHasbuy(this.dataSource.id)

    this.btnConfig = AUtils.mapCourseBtn(this.dataSource, this.$store.$storeUser.isLogin())

    const { convertEndTime, signupStartTime } = this.dataSource
    this.showGiftBtn = AUtils.getGiftStatus({
      convertEndTime,
      signupStartTime
    })
  }

  async created() {
    this.init()
    this.startTick()
  }

  mounted(): void {}

  updated(): void {}

  destroyed(): void {
    this.clearTick()
  }
}
